import React from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
import { Sidebar } from "components/Sidebar";
import { useSelector } from "react-redux";
import { getRoutesByRole } from "routes";
// import { Schedule } from "@mui/icons-material";
import { ScheduledMaintenanceNotice } from "components/CustomComponents";
import { ProductAccessGate } from "components/ProductAccessGate";
import { pathAndProducts } from "services/constants";
import { getProductLanding } from "services/utils/accessedBasedRoute";
import { routeModuleName } from "services/utils/companyAccess";
import { SetupFlow } from "components/SetupFlow";
import { SIDEBAR_PANEL_WIDTH_VAR, SIDEBAR_RAIL_WIDTH } from "services/constants/designTokens";
function Admin() {
  // Below 1400px the sidebar starts collapsed (icon rail) and only expands
  // when the user taps the menu button. 1400 is the same width the Sidebar
  // already uses to auto-collapse on resize and after picking a menu item --
  // starting expanded here used to cover most of a phone screen on first load.
  const [open, setOpen] = React.useState(() => window.innerWidth >= 1400);
  const location = useLocation();
  const mainContentRef = React.useRef(null);
  const { productAccess } = useSelector((state) => state.tokenReducer);
  const routes = getRoutesByRole(productAccess);
  const fallbackPath = getProductLanding(productAccess?.[0]?.product_name).path;

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
  }, [location]);

  // index.html ships <body class="g-sidenav-pinned">; toggleSidenav flips on
  // that class, so it has to match a collapsed first render too.
  React.useLayoutEffect(() => {
    if (window.innerWidth < 1400) {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
    }
  }, []);

  const getRoutes = () => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            render={(routeProps) => {
              const productName = pathAndProducts.find((item) => item.pathname === routeProps.location.pathname.split("/")[2])?.productname;
              // Company changes can revoke this product while granting another.
              // Redirect before mounting the gate for the obsolete destination.
              if (productName && Array.isArray(productAccess) &&
                !productAccess.some((product) => product.product_name === productName)) {
                return <Redirect to={fallbackPath} />;
              }
              const Component = prop.component;
              const moduleName = routeModuleName(routes, routeProps.location.pathname, productName);
              return <ProductAccessGate productName={productName} moduleName={moduleName}><Component {...routeProps} /></ProductAccessGate>;
            }}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const toggleSidenav = () => {
    if (document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
    } else {
      document.body.classList.add("g-sidenav-pinned");
      document.body.classList.remove("g-sidenav-hidden");
    }
    setOpen((current) => !current);
  };

  return (
    <>
      {location.pathname !== "/admin/change/domain" &&
      location.pathname !== "/admin/insufficient/permissions" ? (
        <Sidebar
          routes={routes}
          toggleSidenav={toggleSidenav}
          setOpen={setOpen}
          open={open}
          logo={{
            innerLink: "/",
            imgSrc: require("assets/img/brand/nfblogo.png"),
            imgAlt: "...",
          }}
        />
      ) : null}
      <div
        className="main-content"
        ref={mainContentRef}
        style={
          open
            ? {
                marginLeft:
                  location.pathname === "/admin/change/domain" ||
                  location.pathname === "/admin/insufficient/permissions"
                    ? 0
                    : `calc(${SIDEBAR_RAIL_WIDTH + 2}px + ${SIDEBAR_PANEL_WIDTH_VAR})`,
              }
            : {
                marginLeft:
                  location.pathname === "/admin/change/domain" ||
                  location.pathname === "/admin/insufficient/permissions"
                    ? 0
                    : SIDEBAR_RAIL_WIDTH + 10,
              }
        }
      >
        <ScheduledMaintenanceNotice fetchFromApi />
        {/* First-time organisation setup dialogs, on every screen. */}
        <SetupFlow />
        <Switch>
          {getRoutes()}
          <Redirect from="*" to={fallbackPath} />
        </Switch>
      </div>
    </>
  );
}

export default Admin;
